<template>
  <div class="header_wrap">
    <div class="head_left">
      <i class="el-icon-back" @click="$router.go(-1)"></i>
      <i class="el-icon-s-home" @click="$router.push({ name: 'EvaluationList' })"></i>
      <div class="survey_title">{{ title }}</div>
    </div>
    <div class="head_center">
      <div class="navbar">
        <template v-for="(item, index) in list">
          <div :key="index + 'item'" :class="['nav_item', { active: index === activeIndex }]"
            @click="clickItem(item.route)">
            {{ item.label }}</div>
          <i v-if="index < (list.length - 1)" :key="index + 'icon'" class="el-icon-arrow-right nav-arrow"></i>
        </template>
      </div>
    </div>
    <div class="head-right">
      <!-- <el-button
        plain
        size="small"
        class="plain_primary"
        @click="goto"
      >预览</el-button>
      <el-button
        v-if="surveyBody.status==='editing'"
        type="primary"
        size="small"
        @click="save"
      >发布</el-button>
      <div class="h_logo">
        <head-avatar></head-avatar>
      </div> -->
    </div>
  </div>
</template>

<script>
import { updateSurvey } from "@/api/survey";
// import HeadAvatar from "./HeadAvatar";
export default {
  inject: ["reload"],
  data() {
    return {};
  },
  computed: {
    id() {
      let id = this.$route.params.id;
      return id;
      // let index = id.indexOf("*");
      // if (index !== -1) {
      //   return id.substring(0, index);
      // } else {
      //   return id;
      // }
    },
    title() {
      return this.surveyBody.title;
    },
    surveyBody() {
      return this.$store.state.survey.surveyBody;
    },
    list() {
      let type = this.surveyBody.type;
      let list = [
        {
          label: "测评规则",
          module: "survey",
          route: "EvaluationFormShow"
        },
        {
          label: "测评对象",
          module: "collect",
          route: "SubjectList"
        },
        {
          label: "测评任务",
          module: "collect",
          route: "EvaluationTaskEvent"
        }
      ];

      // 仅仅 admin 与 owner 才能看到数据统计
      const role = this.$store.getters.role;
      if (role === "admin" || role === "owner") {
        list.push({
           label: "数据统计",
           module: "stat",
           route: "EvaluationData"
         });
      }
      if (type === "offline") {
        list[1] = {
          label: "任务分配",
          module: "task",
          route: "task-person"
        };
      }
      return list;
    },
    activeIndex() {
      return this.list.findIndex(
        item => item.route.indexOf(this.$route.name) !== -1
      );
    }
  },
  methods: {
    clickItem(route) {
      this.$router.push({
        name: route,
        params: {
          id: this.id
        }
      });
    },
    goto() {
      this.$router.push({
        path: `/survey/${this.id}/appearance`
      });
    },
    save() {
      let surveyBody = JSON.parse(JSON.stringify(this.surveyBody));
      surveyBody.status = "published";
      let questionsLen = this.surveyBody.questions.length >= 1;
      let startAt = this.surveyBody.started_at;
      let endedAt = this.surveyBody.ended_at;
      // 如果是更新问卷
      if (this.id) {
        if (questionsLen && startAt && endedAt) {
          updateSurvey(this.id, surveyBody).then(() => {
            this.$message({
              type: "success",
              center: true,
              message: "问卷发布成功",
              duration: 1500
            });
            const routeName = this.$route.name;
            if (
              routeName.indexOf("collect") !== -1 ||
              routeName.indexOf("task") !== -1
            ) {
              this.reload();
            } else {
              const router =
                this.surveyBody.type === "online"
                  ? "/collect/link/"
                  : "/task/person/";
              this.$router.push({
                path: `${router}${this.id}`
              });
              this.reload();
            }
          });
        } else {
          let msg = "问卷内容不完整";
          if (!startAt || !endedAt) {
            msg = "请选择日期";
          } else if (!questionsLen) {
            msg = "请添加题目";
          }
          this.$message({
            type: "warning",
            center: true,
            message: msg,
            duration: 1500
          });
        }
      }
    }
  },
  components: {
    // HeadAvatar
  }
};
</script>

<style lang="less" scoped>
.header_wrap {
  height: 64px;
  background-color: #fff;
  font-size: 14px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  // box-shadow: 0 2px 4px 0 rgba(0, 0, 0, .08);
  border-bottom: 1px solid #ededed;
  position: fixed;
  z-index: 300;
  top: 0;
  left: 0;
  right: 0;

  .head_left {
    &>* {
      display: inline-block;
      vertical-align: middle;
    }

    .el-icon-s-home,
    .el-icon-back {
      font-size: 25px;
      font-weight: bold;
      color: #707070;
      margin-left: 30px;
      cursor: pointer;
    }

    .survey_title {
      margin-left: 30px;
    }
  }

  .head_center {
    .navbar {
      display: flex;
      align-items: center;

      .nav_item {
        height: 64px;
        line-height: 64px;
        cursor: pointer;
        position: relative;

        &:hover {
          color: #1d82fc;
        }

        &.active {
          color: #1d82fc;
        }
      }

      .nav-arrow {
        margin: 0 20px;
      }
    }
  }

  .head-right {
    &>* {
      display: inline-block;
      vertical-align: middle;
    }

    .h_logo {
      width: 72px;
      height: 64px;
      border-left: 1px #eaeaea solid;
      margin-left: 20px;
      padding: 12px 0;
      text-align: center;
    }
  }
}
</style>
